var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import SlidingPane from "react-sliding-pane";
import di from "@mainDi/features/webHome";
import PopupWatchlist from "../WatchList/CommonWatchlist/PopupWatchlist";
import AccountsPopups from "../BasicProfile/AccountsPopups";
import { AccountPopupsEnum, ELoginPopupState } from "../BasicProfile/constant";
import { CoAssetTypes, EqAssetTypes } from "./constant";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { useNavigate, useParams } from "react-router-dom";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
var TocHoc = function (props) {
    var device = DeviceContext();
    var params = useParams();
    var navigate = useNavigate();
    var _a = __read(React.useState(AccountPopupsEnum === null || AccountPopupsEnum === void 0 ? void 0 : AccountPopupsEnum.DEFAULT), 2), screenState = _a[0], setScreenState = _a[1];
    var _b = __read(React.useState(), 2), toggledAcc = _b[0], settoggledAcc = _b[1];
    var _c = __read(React.useState({
        accType: "EQ",
        mergeStatus: ELoginPopupState.NOT_ENABLED,
    }), 2), accountState = _c[0], setAccountState = _c[1]; // needed account details to open MF toc
    var _d = __read(useState(), 2), quotesDetailsEntity = _d[0], setQuotesDetailsEntity = _d[1];
    var _e = __read(React.useState(undefined), 2), stockAssetType = _e[0], setStockAssetType = _e[1];
    var _f = __read(React.useState(false), 2), open = _f[0], setOpen = _f[1];
    // const { accTyp: accType, prefAccTyp } = useSelector(
    //   (state: RootState) => state.accountDetailsReducer,
    //   isEqual
    // );
    var removeMarginData = function () {
        tocDi.tocJourney.flushMarginData();
        tocDi.tocJourney.flushMultiQuoteData();
    };
    var checkAccMatchWithStock = function (stockAsType) {
        if (accountState.accType == "EQ" && EqAssetTypes.includes(stockAsType)) {
            return true;
        }
        else if (accountState.accType == "COMEQ" &&
            accountState.mergeStatus === ELoginPopupState.COMPLETED) {
            return true;
        }
        else if (accountState.accType == "CO" &&
            CoAssetTypes.includes(stockAsType)) {
            return true;
        }
        else {
            return false;
        }
    };
    var handleEquityCommodityCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (stockAssetType &&
                accountState.mergeStatus === ELoginPopupState.NOT_ENABLED &&
                (accountState.accType === "CO" || accountState.accType === "EQ")) {
                if (checkAccMatchWithStock(stockAssetType)) {
                    setScreenState(AccountPopupsEnum.TOC_SCREEN);
                    setOpen((props === null || props === void 0 ? void 0 : props.showToc) !== undefined ? props === null || props === void 0 ? void 0 : props.showToc : true);
                }
                else {
                    setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                }
            }
            else if (stockAssetType && accountState.accType === "COMEQ") {
                if (checkAccMatchWithStock(stockAssetType)) {
                    setScreenState(AccountPopupsEnum.TOC_SCREEN);
                    setOpen((props === null || props === void 0 ? void 0 : props.showToc) !== undefined ? props === null || props === void 0 ? void 0 : props.showToc : true);
                }
                else {
                    setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                }
            }
            else if (stockAssetType &&
                accountState.mergeStatus == ELoginPopupState.ONE_ACCOUNT &&
                (accountState.accType === "CO" || accountState.accType === "EQ")) {
                if (checkAccMatchWithStock(stockAssetType)) {
                    setScreenState(AccountPopupsEnum.TOC_SCREEN);
                    setOpen((props === null || props === void 0 ? void 0 : props.showToc) !== undefined ? props === null || props === void 0 ? void 0 : props.showToc : true);
                }
                else {
                    setScreenState(AccountPopupsEnum.NEW_ACCOUNT);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var handleEquityCommCheckIfReqEqOnly = function () {
        var _a;
        var prefAccTyp = (_a = JSON.parse(localStorage.getItem("acc_data"))) === null || _a === void 0 ? void 0 : _a.prefAccTyp;
        if (accountState.accType === "CO" &&
            accountState.mergeStatus === ELoginPopupState.ONE_ACCOUNT) {
            setScreenState(AccountPopupsEnum.NEW_ACCOUNT);
        }
        else if (accountState.mergeStatus === ELoginPopupState.NOT_ENABLED &&
            accountState.accType === "CO") {
            setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
        }
        else if (accountState.accType === "COMEQ" &&
            accountState.mergeStatus === ELoginPopupState.COMPLETED &&
            prefAccTyp === "CO") {
            setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
        }
        else {
            setScreenState(AccountPopupsEnum.TOC_SCREEN);
            setOpen(true);
        }
    };
    React.useEffect(function () {
        if (device) {
            if ((device === null || device === void 0 ? void 0 : device.isDesktop) &&
                !props.hideHeader &&
                !(props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag)) {
                di.header.RemoveHeaderData(true);
                di.footer.setShowFooterUi(true);
            }
            else {
                di.header.RemoveHeaderData(false);
                di.footer.setShowFooterUi(false);
                di.footer.updateShowMob_Menu(false);
            }
        }
        return function () {
            if (!(props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag)) {
                di.header.RemoveHeaderData(true);
                di.footer.setShowFooterUi(true);
                di.footer.updateShowMob_Menu(true);
            }
        };
    }, [device, props.hideHeader]);
    React.useEffect(function () {
        var body = document.querySelector("body");
        body.style.overflow = "hidden";
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS)
            body.style.position = "fixed";
        return function () {
            body.style.overflow = "auto";
            if (isIOS)
                body.style.position = "unset";
        };
    }, []);
    React.useEffect(function () {
        return function () {
            var _a;
            removeMarginData();
            (_a = tocDi === null || tocDi === void 0 ? void 0 : tocDi.tocJourney) === null || _a === void 0 ? void 0 : _a.flushRmsHoldingData();
        };
    }, []);
    // commenting right now once we start working client then we have remove and manage redux
    // React.useEffect(() => {
    //   let accData = {
    //     accType: "",
    //     mergeStatus: "",
    //   };
    //   const accType = JSON.parse(localStorage.getItem("acc_data"))?.accTyp;
    //   if (accType) {
    //     accData.accType = accType;
    //     if (accType == "COMEQ") {
    //       accountDetails.prefAccTyp().then((y) => {
    //         if (y === undefined) {
    //           settoggledAcc("EQ");
    //         } else {
    //           settoggledAcc(y);
    //         }
    //       });
    //     }
    //     accountDetails.getAccountMrgSts().then((x: any) => {
    //       accData.mergeStatus = x;
    //       setAccountState({
    //         accType: accData.accType,
    //         mergeStatus: x,
    //       });
    //     });
    //   }
    // }, [accType]);
    React.useEffect(function () {
        if ((params === null || params === void 0 ? void 0 : params.symbol) && !quotesDetailsEntity && !(props === null || props === void 0 ? void 0 : props.onlyEQACC)) {
            tocDi.tocJourney
                .getMultiQuoteData({
                symLst: [params === null || params === void 0 ? void 0 : params.symbol],
            })
                .then(function (data) {
                if (data)
                    setQuotesDetailsEntity(data.quotesDetailsEntity);
            })
                .catch(function (error) { });
        }
    }, [params === null || params === void 0 ? void 0 : params.symbol]);
    React.useEffect(function () {
        if (accountState.accType && accountState.mergeStatus) {
            if (!(props === null || props === void 0 ? void 0 : props.onlyEQACC)) {
                handleEquityCommodityCheck();
            }
            else {
                handleEquityCommCheckIfReqEqOnly();
            }
        }
    }, [accountState, stockAssetType, props === null || props === void 0 ? void 0 : props.onlyEQACC]);
    React.useEffect(function () {
        var _a;
        if ((quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
            !stockAssetType &&
            !(props === null || props === void 0 ? void 0 : props.onlyEQACC)) {
            setStockAssetType((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.asTyp);
        }
    }, [quotesDetailsEntity]);
    var localStorageFlagKey = "mobileViewFlag";
    React.useEffect(function () {
        if (!(device === null || device === void 0 ? void 0 : device.isDesktop)) {
            localStorage.setItem(localStorageFlagKey, "true");
        }
        return function () {
            localStorage.removeItem(localStorageFlagKey);
        };
    }, [device]);
    React.useEffect(function () {
        var _a;
        var element = document.getElementById("ymPluginDivContainerInitial");
        var isLocalStorageFlagTrue = localStorage.getItem("mobileViewFlag") === "true";
        if (element && (device === null || device === void 0 ? void 0 : device.isMobile) && isLocalStorageFlagTrue) {
            (_a = element === null || element === void 0 ? void 0 : element.classList) === null || _a === void 0 ? void 0 : _a.add("toc-flag-content");
        }
        return function () {
            var _a;
            if (element && (device === null || device === void 0 ? void 0 : device.isMobile)) {
                (_a = element === null || element === void 0 ? void 0 : element.classList) === null || _a === void 0 ? void 0 : _a.remove("toc-flag-content");
            }
        };
    }, [device]);
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            screenState !== AccountPopupsEnum.DEFAULT &&
                screenState !== AccountPopupsEnum.TOC_SCREEN && (React.createElement("div", { className: "profiledata-popup" },
                React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "Switch account type", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: true, setShow: function () {
                        setScreenState(AccountPopupsEnum.DEFAULT);
                        setOpen(false);
                        (props === null || props === void 0 ? void 0 : props.setShowTOC) && (props === null || props === void 0 ? void 0 : props.setShowTOC(false));
                    }, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, callBackFunction: function () {
                            setScreenState(AccountPopupsEnum.DEFAULT);
                            setOpen(false);
                            (props === null || props === void 0 ? void 0 : props.setShowTOC) && (props === null || props === void 0 ? void 0 : props.setShowTOC(false));
                        }, btnvalueleft: screenState == AccountPopupsEnum.NEW_ACCOUNT
                            ? {
                                value: "No, thanks",
                                btnTyp: "midnight-blue-border",
                                className: "",
                            }
                            : screenState ==
                                AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                ? {
                                    value: "Cancel",
                                    btnTyp: "midnight-blue-border",
                                    className: "",
                                }
                                : null, btnvalueright: screenState == AccountPopupsEnum.NEW_ACCOUNT
                            ? {
                                value: "Yes, right away",
                                btnTyp: "midnight-blue",
                                className: "",
                            }
                            : screenState ==
                                AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                ? {
                                    value: "Yes",
                                    btnTyp: "midnight-blue",
                                    className: "",
                                }
                                : null }) }))),
            screenState == AccountPopupsEnum.TOC_SCREEN && (React.createElement(SlidingPane, { hideHeader: true, overlayClassName: "stock-details-overlayblock ".concat((props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag) ? "z-index-very-high" : "", " ").concat(props.blurBackground ? "blur-background" : ""), className: "toc-sliding-pane", isOpen: open, from: "right", onRequestClose: function () {
                    var _a;
                    if (!props.dontCloseOnOutsideClick) {
                        (_a = document
                            .getElementsByClassName("stock-details")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("hideDetailSection");
                        // props?.outsideClick && props?.outsideClick(false);
                        setTimeout(function () {
                            (props === null || props === void 0 ? void 0 : props.setShowTOC) && (props === null || props === void 0 ? void 0 : props.setShowTOC(false));
                            setOpen(false);
                        }, 700);
                        removeMarginData();
                    }
                } },
                React.createElement("div", { className: "toc stock-details" },
                    React.createElement("div", { className: "toc stock-details-head bg_aqua_white w-100 p-0" },
                        React.createElement("div", { className: "stock-details-switch-key txt-midnight-blue", onClick: function () {
                                var _a;
                                if (!(props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag)) {
                                    (_a = document
                                        .getElementsByClassName("stock-details")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("hideDetailSection");
                                    setOpen(false);
                                }
                                (props === null || props === void 0 ? void 0 : props.setShowTOC) && (props === null || props === void 0 ? void 0 : props.setShowTOC(false));
                                (props === null || props === void 0 ? void 0 : props.outsideClick) && (props === null || props === void 0 ? void 0 : props.outsideClick(false));
                            } },
                            React.createElement("i", { className: "edel-icon-cross-bold-small" }))),
                    React.createElement(props.component, __assign({}, props))))))) : (React.createElement(React.Fragment, null, !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(React.Fragment, null,
            screenState !== AccountPopupsEnum.DEFAULT &&
                screenState !== AccountPopupsEnum.TOC_SCREEN && (React.createElement(GenericDrawer, { show: true, setShow: function () {
                    setScreenState(AccountPopupsEnum.DEFAULT);
                    navigate(-1);
                }, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Switch account type")), bodyComp: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, callBackFunction: function () { return navigate(-1); } }) })),
            screenState == AccountPopupsEnum.TOC_SCREEN && (React.createElement(props.component, __assign({}, props))))))))));
};
export default TocHoc;
